import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { isAuthenticatedSelector } from "store/auth/selectors";

import AnalyticsHeader from "./AnalyticsHeader";

import { AnalyticsHeaderProps } from "./AnalyticsHeader.types";

const AnalyticsHeaderContainer = ({
  documentDownloadLoading,
  isRootAdmin,
  analyticsType,
  activePosition,
  onAnalyticsTypeChange,
  onPositionChange,
  onDownloadPDFClick,
}: AnalyticsHeaderProps) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [sticky, setSticky] = useState(false);
  const isAuthenticated = useSelector(isAuthenticatedSelector);

  useEffect(() => {
    const refCurrent = headerRef.current;

    if (!refCurrent) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const rect = refCurrent.getBoundingClientRect();
        
        if (scrollTop === 0) {
          setSticky(false);
          return;
        }
        
        setSticky(!entry.isIntersecting && rect.top < 0);
      },
      { root: null, threshold: 0 }
    );

    observer.observe(refCurrent);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <AnalyticsHeader
      documentDownloadLoading={documentDownloadLoading}
      headerRef={headerRef}
      sticky={sticky}
      isAuthenticated={isAuthenticated}
      isRootAdmin={isRootAdmin}
      analyticsType={analyticsType}
      activePosition={activePosition}
      onAnalyticsTypeChange={onAnalyticsTypeChange}
      onPositionChange={onPositionChange}
      onDownloadPDFClick={onDownloadPDFClick}
    />
  );
};

export default AnalyticsHeaderContainer;
